"use client"

import dynamic from "next/dynamic"

const Toaster = dynamic(
  () => import("react-hot-toast").then((m) => m.Toaster),
  {
    ssr: false
  }
)

export default function ToastNotifications() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        className:
          "dark:bg-slate-800/90 dark:text-white dark:border-slate-700/50",
        duration: 4000,
        error: {
          iconTheme: {
            primary: "#ef4444",
            secondary: "#ffffff"
          }
        },
        style: {
          backdropFilter: "blur(10px)",
          background: "rgba(255, 255, 255, 0.9)",
          border: "1px solid rgba(209, 213, 219, 0.5)",
          color: "#1f2937"
        },
        success: {
          iconTheme: {
            primary: "#10b981",
            secondary: "#ffffff"
          }
        }
      }}
    />
  )
}
